// extracted by mini-css-extract-plugin
export default {"container":"Exchange_container__VWXxg","link":"Exchange_link__mTAim"};